<script setup lang="ts">
import {FormKit} from "@formkit/vue"
import {ref, computed} from "vue"
import {Field_MultiLineText, FieldInterface} from "../../../../gql/types/types";
import { VServices } from "@libVue/base";
import { TranslationService } from "../../../../services/translation.service";

const SERVICES = VServices({translation:TranslationService})
const t = (key: string) => {
  return SERVICES.translation.t(key)
}

const {field} = defineProps({
  field: {
    type: Object as () => Field_MultiLineText,
    required: true
  },
  formValues:{
    type:Object,
    required:true
  }
})
const text = ref("")

const translatedLabel = computed(() => {
  return t(field.label as string)
})
</script>

<template>
<FormKit type="richtext" :id="`field:${field.handle}`" :label="translatedLabel" :name="field.handle" :validation="field.required? 'required':'' " :help="field.instructions" />
</template>

<style scoped lang="scss">

</style>